import React from 'react'
import Helmet from 'react-helmet'
import { Router, Location } from '@reach/router'

import Layout from '../../components/Layout'

import {
  ClientSeachKitProvider,
  ClientHits,
} from '../../components/Client/SearchKit'
import ReportPage from '../../components/Report/Report.js'

const SearchClient = props => (
  <ClientSeachKitProvider>
    <ClientHits />
  </ClientSeachKitProvider>
)

const Reports = () => (
  <Location>
    {({ location }) => (
      <Layout>
        <div style={{ minHeight: 300 }}>
          <Helmet
            title={`Reports | OIRA`}
            meta={[
              {
                name: 'description',
                content: `Reports at the Office of Institutional Research and Assessment of The University of Alabama`,
              },
              {
                name: 'keywords',
                content: `Reports, OIRA, The University of Alabama, AIR, SAIR, ALAIR`,
              },
            ]}
          />
          <div>
            <Router location={location}>
              <ReportPage path={`/reports/:reportId`} />
              <SearchClient path={`/reports/`} />
            </Router>
          </div>
        </div>
      </Layout>
    )}
  </Location>
)

const ReportsWithHashRouting = props =>
  typeof window !== 'undefined' && <Reports />

export default ReportsWithHashRouting
